import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getRseePackagesListLoading: false,
  getRseePackagesListFailed: false,
  getRseePackagesListReject: false,
  getRseePackagesListMessage: [],
  packagesList: [],
  description: '',

  getUserPackagesListLoading: false,
  getUserPackagesListFailed: false,
  getUserPackagesListReject: false,
  getUserPackagesListMessage: [],
  userPackagesList: [],
  userRsee: '',

  buyPackageLoading: false,
  buyPackageFailed: false,
  buyPackageReject: false,
  buyPackageMessage: [],

  getUserPackagesTransactionsLoading: false,
  getUserPackagesTransactionsFailed: false,
  getUserPackagesTransactionsReject: false,
  getUserPackagesTransactionsMessage: [],
  userPackagesTransactions: [],

  buyRseeLoading: false,
  buyRseeFailed: false,
  buyRseeReject: false,
  buyRseeMessage: [],

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_RSEE_PACKAGES_LIST_LOADING: {
      return {
        ...state,
        getRseePackagesListLoading: true,
        getRseePackagesListFailed: false,
        getRseePackagesListReject: false,
        getRseePackagesListMessage: [],
        packagesList: [],
        description: '',
      };
    }
    case actionTypes.GET_RSEE_PACKAGES_LIST_SUCCESS: {
      return {
        ...state,
        getRseePackagesListLoading: false,
        getRseePackagesListFailed: false,
        getRseePackagesListReject: false,
        getRseePackagesListMessage: [],
        packagesList: action.payload.rseePackages,
        description: action.payload.description,
      };
    }
    case actionTypes.GET_RSEE_PACKAGES_LIST_FAILED: {
      return {
        ...state,
        getRseePackagesListLoading: false,
        getRseePackagesListFailed: true,
        getRseePackagesListReject: false,
        getRseePackagesListMessage: [],
        packagesList: [],
        description: '',
      };
    }
    case actionTypes.GET_RSEE_PACKAGES_LIST_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getRseePackagesListLoading: false,
        getRseePackagesListFailed: false,
        getRseePackagesListReject: true,
        getRseePackagesListMessage: message,
        packagesList: [],
        description: '',
      };
    }


    case actionTypes.GET_USER_PACKAGES_LIST_LOADING: {
      return {
        ...state,
        getUserPackagesListLoading: true,
        getUserPackagesListFailed: false,
        getUserPackagesListReject: false,
        getUserPackagesListMessage: [],
        userPackagesList: [],
        userRsee: '',
      };
    }
    case actionTypes.GET_USER_PACKAGES_LIST_SUCCESS: {
      return {
        ...state,
        getUserPackagesListLoading: false,
        getUserPackagesListFailed: false,
        getUserPackagesListReject: false,
        getUserPackagesListMessage: [],
        userPackagesList: action.payload.userPackages,
        userRsee: action.payload.userRsee,
      };
    }
    case actionTypes.GET_USER_PACKAGES_LIST_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getUserPackagesListLoading: false,
        getUserPackagesListFailed: true,
        getUserPackagesListReject: false,
        getUserPackagesListMessage: message,
        userPackagesList: [],
        userRsee: '',
      };
    }
    case actionTypes.GET_USER_PACKAGES_LIST_REJECT: {
      return {
        ...state,
        getUserPackagesListLoading: false,
        getUserPackagesListFailed: false,
        getUserPackagesListReject: true,
        getUserPackagesListMessage: [],
        userPackagesList: [],
        userRsee: '',
      };
    }

    case actionTypes.BUY_PACKAGE_LOADING: {
      return {
        ...state,
        buyPackageLoading: true,
        buyPackageFailed: false,
        buyPackageReject: false,
        buyPackageMessage: [],
      };
    }
    case actionTypes.BUY_PACKAGE_SUCCESS: {
      return {
        ...state,
        buyPackageLoading: false,
        buyPackageFailed: false,
        buyPackageReject: false,
        buyPackageMessage: [],
      };
    }
    case actionTypes.BUY_PACKAGE_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        buyPackageLoading: false,
        buyPackageFailed: true,
        buyPackageReject: false,
        buyPackageMessage: message,
      };
    }
    case actionTypes.BUY_PACKAGE_REJECT: {
      return {
        ...state,
        buyPackageLoading: false,
        buyPackageFailed: false,
        buyPackageReject: true,
        buyPackageMessage: [],
      };
    }

    case actionTypes.GET_USER_PACKAGE_TRANSACTIONS_LOADING: {
      return {
        ...state,
        getUserPackagesTransactionsLoading: true,
        getUserPackagesTransactionsFailed: false,
        getUserPackagesTransactionsReject: false,
        getUserPackagesTransactionsMessage: [],
        userPackagesTransactions: [], // Clear previous data when loading
      };
    }
    case actionTypes.GET_USER_PACKAGE_TRANSACTIONS_SUCCESS: {
      // console.log('Reducer payload:', action.payload);
      return {
        ...state,
        getUserPackagesTransactionsLoading: false,
        getUserPackagesTransactionsFailed: false,
        getUserPackagesTransactionsReject: false,
        getUserPackagesTransactionsMessage: [],
        userPackagesTransactions: action.payload.userPackagesTransactions,
      };
    }
    case actionTypes.GET_USER_PACKAGE_TRANSACTIONS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getUserPackagesTransactionsLoading: false,
        getUserPackagesTransactionsFailed: true,
        getUserPackagesTransactionsReject: false,
        getUserPackagesTransactionsMessage: message,
        userPackagesTransactions: [], // Clear data on failure
      };
    }
    case actionTypes.GET_USER_PACKAGE_TRANSACTIONS_REJECT: {
      return {
        ...state,
        getUserPackagesTransactionsLoading: false,
        getUserPackagesTransactionsFailed: false,
        getUserPackagesTransactionsReject: true,
        getUserPackagesTransactionsMessage: [],
        userPackagesTransactions: [], // Clear data on reject
      };
    }
    case actionTypes.BUY_RSEE_FAILED:{
      const { message } = action.payload;

      return {
        ...state,
        buyRSEELoading: false,
        buyRSEEFailed: true,
        buyRSEEReject: false,
        buyRSEEMessage: message,
      };
    }

    case actionTypes.BUY_RSEE_LOADING:{
      return {
        ...state,
        buyRseeLoading: true,
        buyRseeFailed: false,
        buyRseeReject: false,
        buyRseeMessage: [],
      };
    }
    case actionTypes.BUY_RSEE_REJECT:{
      return {
        ...state,
        buyRseeLoading: false,
        buyRseeFailed: false,
        buyRseeReject: true,
        buyRseeMessage: [],
      };
    }
    case actionTypes.BUY_RSEE_SUCCESS:{
      return {
        ...state,
        buyRseeLoading: false,
        buyRseeFailed: false,
        buyRseeReject: false,
        buyRseeMessage: [],
      };
    }

    default:
      return state;
  }
};
